import {get_user_details,clear_token,get_token} from "@/router";
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import NotificationDropdown from '@/components/Notifications/Notification.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import { client_domain } from "@/main.js";

export default {
  components: {
    NotificationDropdown,
    MenuSideBar,
    Sidebar,
    StickyNav
  },
    data() {
      return ({
        currentProfile: null,
        user_details: {
          "user_id":'',
          "user_role": '',
          "first_name":'',

        },
        showMenu: false,
        profile_data: [],
        school_domain: false
      })
    },
    mounted() {
      
      this.user_details = get_user_details();
      this.get_profile();
      this.getActiveProfile();
      if(client_domain.includes('chiefluthuli')){
        this.school_domain=true
      }
    },

    methods: {
      go_back() {
        if (window.history.length > 1) {
          this.$router.back();
          return;
        }

        this.$router.push({ path: '/home' });
      },
      toggleMenu(e){
      $('.dropdown-menu.show').each(function () {
        $(this).removeClass('show');
        $(this).closest('.dropdown').find('[data-bs-toggle="dropdown"]').attr('aria-expanded', 'false');
      });
      this.showMenu = !this.showMenu;
      e.stopPropagation();
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showMenu = false;
      }
    },
      log_out(){
            clear_token()
            this.$router.push({ path:'/sign_in_finale',});
          },
      toggleSidebar() {
        this.$emit('sidebar-toggle');
      },
      getActiveProfile() {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_profile/`,
            type: "GET",
            headers: {
              Authorization: `Token ${get_token()}`,
              "Content-Type": "application/json",
            },
            success: (response) => {
              if (response.status === "success") {
                this.currentProfile = response.data;
                this.$emit('active-profile-loaded', this.currentProfile)

              }
            },
            error: (xhr, status, error) => {
              console.error("Error fetching active profile:", error);
            },
          });
        },

       get_profile() {
              this.isLoading = true;
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
                type: 'GET',
                headers: {
                  Authorization: `Token ${get_token()}`,
                  'Content-Type': 'application/json',
                },
                data: {
                  user_id: this.user_details.user_id
                },
                success: (data) => {
                  if (data.status === 'success' && data.data.profile_data) {
                      this.profile_data = data.data.profile_data;

                  }
                },
                complete: () => {
                  this.isLoading = false;
                },
              });
            },
    }
  }
